import React, { Component } from "react";
import PropTypes from "prop-types";
import { Map, List } from "immutable";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, reset, touch, focus } from "redux-form";

import moment from "moment";
import axios from "axios";

import { StartExam } from "components";

import * as common from "libs/commonFunc";
import * as validFunc from "libs/validation";
import { examNameAsyncValidate } from "libs/validation";
import * as examLib from "libs/examLib";

import * as examActions from "modules/exam";
import * as TagActions from "modules/tag";
import * as templateActions from "modules/template";
import * as templateAttachActions from "modules/templateAttach";
import * as currentStatusActions from "modules/currentStatus";
import * as examListActions from "modules/examList";
import * as examSummaryActions from "modules/examSummary";
import * as adminActions from "modules/admin";

class CtStartExam extends Component {
  constructor(props) {
    super(props);
    //this.maxVisitedPage = 1;
    this.state = {
      step: 1,
      visible: false,
      loading: false,
      examFail: null,
      licenseResult: null,
      examSystemUrl: "",
    };
  }

  // 훈련 실시 시작 정보 조회
  getPrepareExam = async () => {
    try {
      const { ExamActions } = this.props;
      await ExamActions.prepareExam();
    } catch (e) {
      console.log(e);
    }

    this.setState({
      loading: false,
    });
  };

  // 훈련 실시 태그 정보 조회
  getTargetTags = async () => {
    try {
      const { TagActions, formStore } = this.props;

      // 훈련명 중복 체크
      if (!(await validFunc.examNameValidate(formStore.values.examName))) {
        // 훈련 메일 나눔 발송 체크
        if (
          Number(formStore.values.sendReserveEnable) &&
          !!(
            common.epochFromDate(formStore.values.examEndDate) <
            common.epochFromDate(formStore.values.examStartDate) +
              Number(formStore.values.sendReservePeriod) * 86400
          )
        ) {
          this.goStep(-1);
        } else {
          await TagActions.getTag();
        }
      } else {
        this.goStep(-1);
      }
    } catch (e) {
      console.log(e);
    }

    this.setState({
      loading: false,
    });
  };

  // 훈련 실시 템플릿 정보 조회
  getTemplates = async () => {
    try {
      const { TemplateActions, TemplateAttachActions } = this.props;
      const params = {
        type: "startExam",
      };
      await TemplateActions.getTemplate(params);
      await TemplateAttachActions.getAttach();
    } catch (e) {
      console.log(e);
    }

    this.setState({
      loading: false,
    });
  };

  // 훈련 실시 라이센스 정보 조회
  getExamLicense = async (step) => {
    let licenseResult = null;

    try {
      const { values } = this.props.formStore;
      const params = {};
      if (values.isAllTarget) {
        params["isAllTarget"] = values.isAllTarget;
      } else {
        params["examTargetTagArray"] = values.examTargetTag.join(",");
      }
      if (!!values.exceptExamTargetTag) {
        params["exceptExamTargetTagArray"] = values.exceptExamTargetTag.join(
          ","
        );
      }
      params["examStartEpoch"] = moment(values.examStartDate).unix().toString();

      // 템플릿에서 검사시 훈련
      if (step === 5) {
        if (
          values.examTemplate &&
          Array.isArray(values.examTemplate) &&
          values.examTemplate.length > 0
        ) {
          const serviceTempArray = [];
          const examTempArray = [];
          for (let j = 0, m = values.examTemplate.length; j < m; j++) {
            const info = values.examTemplate[j].split("+");
            if (info[2]) {
              serviceTempArray.push(info[2]);
            } else {
              examTempArray.push(info[1]);
            }
          }

          params.examServiceTemplateNoArray = JSON.stringify(serviceTempArray);
          params.examTemplateNoArray = JSON.stringify(examTempArray);
        }
      }

      const respObj = await examLib.getExamLicense(params);
      if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
        // 대상자가 5명 이하의 경우 라이센스 체크 안함
        if (respObj.data.targetAllCount < 6) {
          // '훈련 가능: 대상자가 5명 이하'
        } else if (Array.isArray(respObj.data.list) || respObj.data.error) {
          licenseResult = respObj.data;
        }

        // 템플릿 선택으로 이동
        if (step === 4) {
          // 라이센스 존재
          if (respObj.data.isValidLicense === 1 && respObj.data.targetAllCount > 0) {
            this.getTemplates();
          } else {
            // 라이센스 실패시 이전 페이지
            this.goStep(-1);
          }
          // 라이센스 체크(횟수 라이센스의 경우 남은 횟수보다 많은 훈련을 내릴때의 처리)
        } else if (step === 5) {
          if (respObj.data.isValidLicense === 1) {
            this.startExam();
          } else {
            this.setState({
              step: 4,
              loading: false,
              licenseResult,
            });
            return;
          }
        } else {
          //
        }
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({
      loading: false,
      licenseResult,
    });
  };

  // 훈련 시스템 URL 조회
  getExamSystemUrl = async () => {
    const response = await axios.get("/api/v1/SystemUrl");
    if (response && response.data) {
      const { list, error } = response.data;
      if (!error) {
        const url = list.length > 0 ? list[0].url : "";
        this.setState({
          examSystemUrl: url,
        });
      }
    }
  };

  // 훈련 실시 라이센스 정보 초기화
  initExamLicense = () => {
    this.setState({
      loading: false,
      licenseResult: null,
    });
  };

  // 태그 목록 초기화
  initTargetTags = () => {
    alert("태그 목록 초기화");
  };

  // 템플릿 목록 초기화
  initTemplates = () => {
    alert("템플릿 목록 초기화");
  };

  // 훈련 시작
  startExam = async () => {
    const { invalid, formStore } = this.props;
    const values = formStore.values;
    // 악성파일 화면 잠금 시간 처리
    if (
      Number(values.attachScreenLock) === 1 &&
      values.isAttachScreenView &&
      common.epochFromDate(values.examEndDate) <=
        common.epochFromDate(values.attachScreenLockDate)
    ) {
      this.setState({
        step: 4,
        loading: false,
      });

      this.pageAction(4);
      return;
    }

    // 초기화
    this.setState({
      examFail: null,
      licenseResult: null,
    });

    let anyError = false;
    const errorType = [
      "syncErrors",
      "syncWarnings",
      "asyncErrors",
      "asyncWarnings",
    ];
    for (let i = 0, l = errorType.length; i < l; i++) {
      if (formStore[errorType[i]]) {
        for (const field in formStore[errorType[i]]) {
          if (formStore[errorType[i]].hasOwnProperty(field)) {
            anyError = true;
            console.log(
              "startExam " +
                errorType[i] +
                " error / " +
                field +
                ":" +
                formStore[errorType[i]][field]
            );
          }
        }
      }
    }

    // 악성파일 화면 잠금 시간 처리
    if (Number(values.attachScreenLock) === 1 && values.isAttachScreenView) {
      if (
        common.epochFromDate(formStore.values.examEndDate) <=
        common.epochFromDate(formStore.values.attachScreenLockDate)
      ) {
        anyError = true;
      }
    }

    //ㅁㅁ
    if (!invalid && !anyError && values) {
      // 에러 확인 다시 invalid 는 보이는 것만 체크함
      const params = {
        examName: values.examName,
        examStartEpoch: moment(values.examStartDate).unix().toString(),
        examEndEpoch: moment(values.examEndDate).unix().toString(),
      };

      // 모든 대상자 선택
      if (values.isAllTarget) {
        params.isAllTarget = values.isAllTarget;
      } else if (
        values.examTargetTag &&
        Array.isArray(values.examTargetTag) &&
        values.examTargetTag.length > 0
      ) {
        //메일 발송 대상자 태그
        params.examTargetTagArray = values.examTargetTag.join(",");
      }
      // 제외 대상자
      if (values.exceptExamTargetTag && Array.isArray(values.exceptExamTargetTag) && values.exceptExamTargetTag.length > 0) {
        params.exceptExamTargetTagArray = values.exceptExamTargetTag.join(',');
      }
      // 메일 발송 대상자 이메일
      // if (values.examTargetEmail && Array.isArray(values.examTargetEmail) && values.examTargetEmail.length > 0) {
      //   params.examTargetEmailJson = JSON.stringify(values.examTargetEmail);
      // }
      // 훈련 대상자 선택 비율
      if (values.examTargetRandomPer) {
        params.examTargetRandomPer = values.examTargetRandomPer;
      }
      // 훈련 메일 나눔 발송
      if (Number(values.sendReserveEnable) === 1 && values.sendReservePeriod) {
        params.sendReservePeriod = Number(values.sendReservePeriod);

        // 메일 발송 시간
        if (values.sendReserveHour) {
          params.sendReserveStartHour = values.sendReserveHour[0];
          params.sendReserveEndHour = values.sendReserveHour[1];
        }
      }

      // 악성파일 화면 잠금 기능
      if (Number(values.attachScreenLock) === 1 && values.isAttachScreenView) {
        params.attachScreenLockEpoch =
          moment(values.attachScreenLockDate).unix() +
          values.attachScreenLockHour +
          values.attachScreenLockMin;
      }

      if (
        values.examTemplate &&
        Array.isArray(values.examTemplate) &&
        values.examTemplate.length > 0
      ) {
        const serviceTempArray = [];
        const examTempArray = [];
        for (let j = 0, m = values.examTemplate.length; j < m; j++) {
          const info = values.examTemplate[j].split("+");
          if (info[2]) {
            serviceTempArray.push(info[2]);
          } else {
            examTempArray.push(info[1]);
          }
        }

        params.examServiceTemplateNoArray = JSON.stringify(serviceTempArray);
        params.examTemplateNoArray = JSON.stringify(examTempArray);
      }

      if (values.useExamSystemUrl === "1" && !!values.examSystemUrl) {
        params.examUrl = values.examSystemUrl;
      }

      try {
        const { ExamActions } = this.props;
        await ExamActions.startExam(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      // 에러 있음
      this.setState({
        examFail:
          "invalid: " +
          invalid +
          ", anyError: " +
          anyError +
          ", values: " +
          (values ? "yes" : "no"),
      });
      console.log("startExam error!");
    }

    this.setState({
      loading: false,
    });
  };

  pageAction = (step) => {
    // 환경 검사 시작
    if (step === 1) {
      this.getPrepareExam();

      // 일반설정으로 이동
    } else if (step === 2) {
      //
      // 대상자 지정으로 이동
    } else if (step === 3) {
      this.getTargetTags();

      // 라이센스 체크 후 성공시 템플릿으로 이동
    } else if (step === 4) {
      this.getExamLicense(step);
      this.getExamSystemUrl();

      // 훈련 실행을 클릭함. 결과보기로 이동
    } else if (step === 5) {
      this.getExamLicense(step);
    } else {
      // 기타
    }
  };

  goStep = (direction) => {
    const beforeStep = this.state.step;

    if (!direction) {
      return;
    }

    this.setState({
      step: beforeStep + direction,
      loading:
        beforeStep === 2 || beforeStep === 4 || beforeStep + direction === 4
          ? true
          : false,
      licenseResult: null,
    });

    this.pageAction(beforeStep + direction);
  };

  handleOnToggleModal = () => {
    const { dispatch } = this.props;

    this.setState({
      step: 1,
      loading: true,
      visible: !this.state.visible,
      examFail: null,
      licenseResult: null,
    });

    // 알려진 버그로 아직 수정되지 않음
    // reset 후에는 validate 가 change 이벤트 전까지 동작하지 않음
    dispatch(reset("startExam"));
    // this.props.destroy();
    // this.props.initialize();
  };

  handleNextStep = () => {
    this.goStep(1);
  };

  handlePrevStep = () => {
    this.goStep(-1);
  };

  handleOnOpenModal = async () => {
    this.pageAction(1);
  };

  handleNavigatePage = (link) => {
    this.props.history.push(link);
  };

  markFieldValidate = () => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus("startExam", field));
            dispatch(touch("startExam", field));
          }
        }
      }
    }
  };

  // 결과보기로 이동
  moveExamResult = (examNo) => {
    const {
      CurrentStatusActions,
      ExamListActions,
      examResultData,
    } = this.props;

    CurrentStatusActions.changeExamSummary({
      name: "selected",
      value: examResultData.success[0].examNoArray[0],
    });
    ExamListActions.changeExamListParam({
      name: "filter",
      value: Map({}),
    });

    this.handleOnToggleModal();
    this.handleNavigatePage("/main/exam");
  };

  render() {
    const {
      formStore,
      invalid,
      templateData,
      tagData,
      examResultData,
      examPrepareData,
    } = this.props;
    const {
      step,
      visible,
      loading,
      examFail,
      licenseResult,
      examSystemUrl,
    } = this.state;
    const {
      handleOnOpenModal,
      handleOnToggleModal,
      handleNextStep,
      handlePrevStep,
      initTargetTags,
      initTemplates,
      handleNavigatePage,
      markFieldValidate,
      initExamLicense,
      moveExamResult,
    } = this;

    return (
      <StartExam
        step={step}
        visible={visible}
        loading={loading}
        examFail={examFail}
        licenseResult={licenseResult}
        initExamLicense={initExamLicense}
        formStore={formStore}
        invalid={invalid}
        handleOnOpenModal={handleOnOpenModal}
        handleOnToggleModal={handleOnToggleModal}
        handleNextStep={handleNextStep}
        handlePrevStep={handlePrevStep}
        examPrepareData={examPrepareData}
        // 태그 초기화
        initTargetTags={initTargetTags}
        // 템플릿 초기화
        initTemplates={initTemplates}
        tagData={tagData}
        templateData={templateData}
        examResultData={examResultData}
        handleNavigatePage={handleNavigatePage}
        markFieldValidate={markFieldValidate}
        // 결과보기로 이동
        moveExamResult={moveExamResult}
        examSystemUrl={examSystemUrl}
      />
    );
  }
}

const mapStateToProps = (state) => {
  let tagData = state.tag.get("tagDataByTagNo");
  if (tagData && Map.isMap(tagData)) {
    tagData = tagData.toJS();
  } else {
    tagData = {};
  }
  let templateData = state.template.get("startExamTemplates");
  if (templateData && Map.isMap(templateData)) {
    templateData = templateData.toJS().success;
  } else {
    templateData = [];
  }
  let examPrepareData = state.exam.get("startExamPrepare");
  if (examPrepareData && Map.isMap(examPrepareData)) {
    examPrepareData = examPrepareData.toJS();
  } else {
    examPrepareData = {};
  }
  let examResultData = state.exam.get("startExamResult");
  if (examResultData && Map.isMap(examResultData)) {
    examResultData = examResultData.toJS();
  } else {
    examResultData = {};
  }

  return {
    tagData: tagData,
    templateData: templateData,
    examResultData: examResultData,
    examPrepareData: examPrepareData,
    // redux-form store 데이터
    formStore: state.form["startExam"],
  };
};

const mapDispatchToProps = (dispatch) => ({
  ExamActions: bindActionCreators(examActions, dispatch),
  TemplateActions: bindActionCreators(templateActions, dispatch),
  TemplateAttachActions: bindActionCreators(templateAttachActions, dispatch),
  TagActions: bindActionCreators(TagActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ExamListActions: bindActionCreators(examListActions, dispatch),
  ExamSummaryActions: bindActionCreators(examSummaryActions, dispatch),
  AdminActions: bindActionCreators(adminActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: "startExam",
      asyncValidate: examNameAsyncValidate,
      asyncBlurFields: ["examName"],
      destroyOnUnmount: false,
      touchOnChange: true, // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
    })(CtStartExam)
  )
);



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtStartExam.js